
import { BillPaymentReport } from "../../classes"

const BillPaymentReportModule = {
  namespaced: true,
  state: {
    billPaymentReports: [],
  },
  mutations: {
    setBillPaymentReports(state, billPaymentReports) {
      state.billPaymentReports = billPaymentReports || []
    },
  },
  actions: {
    getBillPaymentReportBetweenDateByMarket: async ({ commit }, { marketId, startDate, endDate }) => {
      try {
        let result = await BillPaymentReport.getBillPaymentReportBetweenDateByMarket(marketId, startDate, endDate);
        commit('setBillPaymentReports', result || [])
        return result;
      } catch (error) {
        throw error
      }
    },
    getBillPaymentReportBetweenDateByProject: async ({ commit }, { projectId, startDate, endDate }) => {
      try {
        let result = await BillPaymentReport.getBillPaymentReportBetweenDateByProject(projectId, startDate, endDate);
        commit('setBillPaymentReports', result || [])
        return result;
      } catch (error) {
        throw error
      }
    },
  },
  getters: {

  },
};
export default BillPaymentReportModule;
